import React, {
  useContext,
} from 'react';
import clsx from 'clsx';
import EyeIcon from 'core/icons/eye';
import Button from 'pages/Dashboard/components/Button';
import {
  WizardContext,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/wizardContext';
import {
  UploadIcon,
} from 'core/icons';
import FilePicker from 'pages/Dashboard/components/FilePicker';
import {
  MultimediaType,
} from 'pages/Dashboard/utils/constants';
import {
  useGetAllowedFileTypes,
} from 'pages/Dashboard/hooks/media';

export default function EOBPreviewButton() {
  const { hasDoc, toggleDoc, visibleDoc, handleEOBDrop } = useContext(WizardContext);
  const allowedFileTypes = useGetAllowedFileTypes(MultimediaType.EOB);

  return hasDoc ? (
    <Button
      variant="outlined"
      color="primary"
      className={clsx('!h-6 !py-0 !pl-2 relative !-top-2 !-right-2', {
        '!border-blue-500': hasDoc,
      })}
      onClick={() => { toggleDoc(!visibleDoc); }}
      disabled={!hasDoc}
    >
      <EyeIcon
        className={clsx('!w-4 !h-4 mr-2', {
          '!text-blue-500': hasDoc,
        })}
      />
      {visibleDoc ? 'Hide ' : 'Show '}
      EOB
    </Button>
  ) : (
    <FilePicker
      onFileUpload={handleEOBDrop}
      variant="outlined"
      color="secondary"
      className="!px-2 !h-6 relative !-top-2 !-right-2"
      allowedFileTypes={allowedFileTypes}
    >
      <div className="flex gap-2">
        <UploadIcon className="!w-3.5 !h-3.5" />
        Upload EOB
      </div>
    </FilePicker>
  );
}
